import React from "react";
import banderaLogo from "../assets/bandera.png";
import useReveal from "../hooks/useReveal";

// Lines Bandera represents in Trinidad & Tobago and the wider Caribbean.
const BRANDS = [
  { name: "Ulterra", detail: "PDC drill bits" },
  { name: "King Dream", detail: "Roller cone bits" },
  { name: "Derrick", detail: "Shale shakers" },
  { name: "Bestolife", detail: "Premium thread compounds" },
];

export default function Bandera() {
  const leftRef = useReveal();
  const rightRef = useReveal();

  return (
    <section
      id="bandera"
      className="relative overflow-hidden border-y border-white/10 bg-ink-950 py-24 lg:py-32"
    >
      <div className="absolute inset-0 bg-grid bg-grid opacity-30" />
      <div className="absolute -left-40 top-1/4 h-[26rem] w-[26rem] rounded-full bg-amber-500/10 blur-[130px]" />

      <div className="relative mx-auto max-w-shell px-6 lg:px-10">
        <div className="grid gap-14 lg:grid-cols-12 lg:gap-20">
          {/* Left — the brand */}
          <div ref={leftRef} className="reveal lg:col-span-5">
            <p className="kicker mb-6">03 — Sister company</p>

            <div className="mb-8 inline-flex bg-white p-4">
              <img
                src={banderaLogo}
                alt="Bandera Oil Tools"
                className="h-12 w-auto"
              />
            </div>

            <h2 className="h-display text-5xl sm:text-6xl lg:text-[4.25rem]">
              Bandera
              <br />
              <span className="text-flame-500">Oil Tools</span>
            </h2>

            <p className="mt-8 text-steel-300">
              Bandera Oil Tools supplies drill bits and drilling consumables for
              onshore and offshore operations across Trinidad & Tobago and the
              wider Caribbean.
            </p>
            <p className="mt-5 text-steel-300">
              Bandera is the regional agent for a stocked line of premium
              drilling products — holding inventory locally so operators get
              fast delivery and hands-on technical support on product selection.
            </p>

            <a
              href="#contact"
              onClick={(e) => {
                e.preventDefault();
                document
                  .getElementById("contact")
                  ?.scrollIntoView({ behavior: "smooth" });
              }}
              className="btn-ghost group mt-10"
            >
              Enquire about Bandera
              <span className="transition-transform duration-300 group-hover:translate-x-1">
                →
              </span>
            </a>
          </div>

          {/* Right — represented lines */}
          <div ref={rightRef} className="reveal lg:col-span-7">
            <p className="mb-6 font-mono text-[11px] uppercase tracking-kicker text-steel-400">
              Lines represented
            </p>

            <div className="grid gap-px border border-white/10 bg-white/10 sm:grid-cols-2">
              {BRANDS.map((brand, i) => (
                <div
                  key={brand.name}
                  className="group relative overflow-hidden bg-ink-950 p-8 transition-colors duration-500 hover:bg-ink-900 lg:p-10"
                >
                  <span className="absolute right-6 top-6 font-mono text-[11px] text-steel-400/60">
                    0{i + 1}
                  </span>
                  <span className="absolute inset-x-0 top-0 h-[2px] origin-left scale-x-0 bg-flame-500 transition-transform duration-500 group-hover:scale-x-100" />

                  <h3 className="h-display text-3xl transition-colors duration-300 group-hover:text-flame-500 lg:text-4xl">
                    {brand.name}
                  </h3>
                  <p className="mt-2 font-mono text-[11px] uppercase tracking-wide2 text-steel-400">
                    {brand.detail}
                  </p>
                </div>
              ))}
            </div>

            {/* Footnote strip */}
            <div className="mt-6 flex flex-wrap items-center gap-x-8 gap-y-3 border border-white/10 bg-ink-900/60 px-7 py-5">
              <div>
                <p className="h-display text-2xl text-white">Onshore</p>
                <p className="font-mono text-[10px] uppercase tracking-wide2 text-steel-400">
                  & offshore supply
                </p>
              </div>
              <span className="hidden h-8 w-px bg-white/10 sm:block" />
              <div>
                <p className="h-display text-2xl text-white">Caribbean</p>
                <p className="font-mono text-[10px] uppercase tracking-wide2 text-steel-400">
                  Regional coverage
                </p>
              </div>
              <span className="hidden h-8 w-px bg-white/10 sm:block" />
              <div>
                <p className="h-display text-2xl text-white">Local stock</p>
                <p className="font-mono text-[10px] uppercase tracking-wide2 text-steel-400">
                  Fast delivery
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
